import { render, staticRenderFns } from "./AnaliseFaturamentoVendedor.vue?vue&type=template&id=7910b805&scoped=true&"
import script from "./AnaliseFaturamentoVendedor.vue?vue&type=script&lang=js&"
export * from "./AnaliseFaturamentoVendedor.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseFaturamentoVendedor.vue?vue&type=style&index=0&id=7910b805&scoped=true&lang=css&"
import style1 from "./AnaliseFaturamentoVendedor.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910b805",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
